import { useMutation, useQuery } from '@tanstack/react-query';
import { httpService } from '../../../utils/apiService';
import queryString from 'query-string';

export const useFetchUsers = ({ operatorId, search, offset, limit, page, sortBy, sortOrder }) => {
  return useQuery({
    queryKey: ['users', operatorId, search, offset, limit, page, sortBy, sortOrder],
    queryFn: async () => {
      const response = await httpService.post(`/customer/list?offset=${offset}&limit=${limit}&search=${search}&sortBy=${sortBy}&sortOrder=${sortOrder}`, {
        operatorId,
      });
      return response.data;
    },
    keepPreviousData: true,
    enabled: !!operatorId,
    refetchOnWindowFocus: false,
  });
};

export const useBlockUnblockUser = (options = {}) => {
  return useMutation({
    mutationKey: ['TOGGLE_BLOCK_UNBLOCK_USER'],
    mutationFn: async (payload) => {
      const { id, status, operatorId } = payload;

      const response = await httpService.post(
        `customer/toggle-block-unblock/${id}`,
        {
          status,
          operatorId,
        }
      );

      return response.data;
    },
    ...options,
  });
};

export const useCreateCustomer = (options = {}) => {
  return useMutation({
    mutationKey: ['CREATE_CUSTOMER'],
    mutationFn: async (payload) => {
      const response = await httpService.post('/customer/create', payload);
      return response.data;
    },
    ...options,
  });
};

export const useEditCustomer = (id, options = {}) => {
  return useMutation({
    mutationKey: ['Update_CUSTOMER'],
    mutationFn: async (payload) => {
      const response = await httpService.post(
        `/customer/update/${id}`,
        payload
      );
      return response.data;
    },
    ...options,
  });
};

export const useFetchClients = (pagination, token) => {
  const { offset, limit, search } = pagination;

  return useQuery({
    queryKey: ['client-list', offset, limit, search],
    queryFn: async () => {
      const params = queryString.stringify({ offset, limit, search });
      const response = await httpService.get(
        `client/list?${params}`,
        token,
        null
      );

      return response.data.data;
    },
    keepPreviousData: true,
    enabled: !!token,
    refetchOnWindowFocus: false,
  });
};

// only when Wallet is enabled
export const useAddCustomerCredit = (options = {}) => {
  return useMutation({
    mutationKey: ['ADD_CUSTOMER_CREDIT'],
    mutationFn: async (payload) => {
      const response = await httpService.post('/customer/add-credit-by-authority', payload);
      return response.data;
    },
    ...options,
  });
};

export const useFetchCustomerDetails = (id, operatorId) => {
  return useQuery({
    queryKey: ['customer-details', id, operatorId],
    queryFn: async () => {
      const response = await httpService.post(`/customer/single-customer/${id}`, {
        operatorId,
      });
      return response.data?.data?.singleCustomerData || response.data?.data || response.data;
    },
    enabled: !!id && !!operatorId,
    refetchOnWindowFocus: false,
  });
};

export const useGetCustomerPin = (options = {}) => {
  return useMutation({
    mutationKey: ['GET_CUSTOMER_PIN'],
    mutationFn: async ({ id }) => {
      const response = await httpService.post(`/customer/get-pin/${id}`);
      return response.data?.data;
    },
    ...options,
  });
};

export const useResetCustomerPin = (options = {}) => {
  return useMutation({
    mutationKey: ['RESET_CUSTOMER_PIN'],
    mutationFn: async ({ id }) => {
      const response = await httpService.post(`/customer/reset-pin/${id}`);
      return response.data;
    },
    ...options,
  });
};
